import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const printTemplates = v.union(
  v.literal("thermal-58"),
  v.literal("thermal-80"),
  v.literal("half-letter"),
  v.literal("letter"),
  v.literal("a4"),
);

export const validatorLogisticsConfiguration = v.object({
  branchId: v.id("branches"),
  autoAssignToDefault: v.boolean(),
  defaultCalendarId: v.optional(v.id("consolidation_calendars")),
  defaultCarrierId: v.optional(v.id("carriers")),
  defaultShippingRouteId: v.optional(v.id("shipping_routes")),
  defaultBoxTypeId: v.optional(v.id("box_types")),
  notifyOnShipmentFull: v.optional(v.boolean()),
  notifyOnShipmentCreated: v.optional(v.boolean()),
  notifyThresholdPercent: v.optional(v.number()),
  defaultAdvancePayment: v.optional(v.number()),
  requireAdvancePayment: v.optional(v.boolean()),
  requirePickupVerification: v.optional(v.boolean()),

  // Opciones de campos en formulario de paquetes
  showWeightField: v.optional(v.boolean()),
  showDeclaredValueField: v.optional(v.boolean()),
  allowMultiplePackages: v.optional(v.boolean()),

  // Opciones de clientes
  allowSameSenderAsRecipient: v.optional(v.boolean()),

  // Comprobantes de paquete
  packageReceiptTemplate: v.optional(printTemplates),
  packageReceiptCopies: v.optional(v.number()),
  printReceiptAfterCreate: v.optional(v.boolean()),
  printReceiptAfterPickup: v.optional(v.boolean()),

  // Notificaciones por email - Al crear paquete
  emailOnPackageCreated: v.optional(v.boolean()),
  emailSenderOnCreate: v.optional(v.boolean()),
  emailRecipientOnCreate: v.optional(v.boolean()),

  // Notificaciones por email - Cambios de estado
  emailOnStatusChange: v.optional(v.boolean()),
  emailSenderOnStatusChange: v.optional(v.boolean()),
  emailRecipientOnStatusChange: v.optional(v.boolean()),

  // Notificaciones por email - Estados específicos
  emailOnConsolidated: v.optional(v.boolean()),
  emailOnInTransit: v.optional(v.boolean()),
  emailOnDelivered: v.optional(v.boolean()),
  emailOnDeliveryFailed: v.optional(v.boolean()),
  emailOnReturned: v.optional(v.boolean()),

  // Notificaciones por email - Órdenes
  emailOnOrderConfirmed: v.optional(v.boolean()),

  // Notificaciones por email - Shipments
  emailOnShipmentClosed: v.optional(v.boolean()),
  emailOnShipmentDeparted: v.optional(v.boolean()),
  emailOnShipmentArrived: v.optional(v.boolean()),

  // Términos y condiciones
  termsAndConditions: v.optional(v.string()),
  includeTermsInEmails: v.optional(v.boolean()),

  // Configuración de textos de correos electrónicos
  emailCompanyName: v.optional(v.string()), // Nombre que aparece en el header del correo
  emailFooterText: v.optional(v.string()), // Texto del footer del correo
  emailContactInfo: v.optional(v.string()), // Información de contacto en correos

  // Mensajes personalizados por tipo de evento
  emailMessagePackageCreated: v.optional(v.string()),
  emailMessageBoxDelivered: v.optional(v.string()),
  emailMessageBoxPickedUp: v.optional(v.string()),
  emailMessageStatusChanged: v.optional(v.string()),
  emailMessageConsolidated: v.optional(v.string()),
  emailMessageInTransit: v.optional(v.string()),
  emailMessageDelivered: v.optional(v.string()),
  emailMessageDeliveryFailed: v.optional(v.string()),
  emailMessageReturned: v.optional(v.string()),
  emailMessageShipmentClosed: v.optional(v.string()),
  emailMessageShipmentDeparted: v.optional(v.string()),
  emailMessageShipmentArrived: v.optional(v.string()),

  internalControl,
});

export const logistics_configurations = defineTable(
  validatorLogisticsConfiguration,
)
  .index("by_branch_id", ["branchId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ]);
